import { io } from "socket.io-client";
export function create(ctx) {
    return io(ctx.url);
}
